export default "__VITE_ASSET__4700a207__"